import { Option } from '../../../../../core/models/option.model';
import { StatusRequest } from '../../../../../core/models/request-status.model';

export enum SUBTOPIC_ACTIONS {
  SHOW_FORM = 'SHOW_FORM',
  REQUIRE_LOGIN = 'REQUIRE_LOGIN',
  CONTENT = 'CONTENT',
}

export interface SubTopic {
  options?: Option[];
  action?: SUBTOPIC_ACTIONS;
  content?: string;
}

export interface SubTopicRequest extends StatusRequest {
  subTopic?: SubTopic;
}

export interface ContactForm {
  topic?: string;
  subTopic?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  extension?: string;
  companyName?: string;
  businessType?: string;
  country?: string;
  region?: string;
  city?: string;
  zipCode?: string;
  info?: string;
  optIn?: boolean;
  agreeWithPolicy?: boolean;
  token?: string;
}

export interface TopicSendItem {
  topicCode?: string;
  optionCode?: string;
  firstName?: string;
  lastName?: string;
  workEmail?: string;
  phoneNumber?: string;
  extension?: string;
  companyName?: string;
  businessType?: string;
  country?: string;
  region?: string;
  city?: string;
  zipcode?: string;
  description?: string;
  marketingTerms?: boolean;
  policyTerms?: boolean;
}
